module.exports = __webpack_public_path__ + "img/50_17.c5774112.png";